export const NAME = 'footer';